import React, { useState } from 'react'
import Product from '../../../components/Product/Product'
import { GetDocs } from '../../../firebase/utils'
import { useEffect } from 'react'

import './Products.css'
import { useContext } from 'react'
import { DashboardContext } from '../../../Hooks/DashboardContext'
import Loading from '../../../components/Loading/Loading'
import ConfirmDialog from '../../../components/ConfirmDialog/ConfirmDialog'
import { useNavigate } from 'react-router-dom'
import Pill from '../../../components/Pill/Pill'


const Products = () => {
  

  const [Produits,setProduits]=useState(null)

  const {searchValue,setcurrentProduct}=useContext(DashboardContext)

  const [filteredItems,setfilteredItems]=useState(null)
  const navigate = useNavigate();


 
  useEffect(() => {

    document.querySelector('#Loading').showModal()
    GetDocs("Produits").then((result)=>setProduits(result))
   
  }, [/*Produits*/])

  useEffect(
    ()=>{
      if (Produits===null) return
      document.querySelector('#Loading').close()

      setfilteredItems(Produits.filter(
        (prod)=>
        prod.Nom.toLowerCase().includes(searchValue.toLowerCase())
      ))

    },[searchValue,Produits]
  )
  
  const RemplirForm=()=>{
    navigate('../ProductsMenu/AddProduct')
    setcurrentProduct(null)

}


  return (
    <div className='Products_container'>
      <div className='ajoutProd'>
        <Pill bgcolor={'#e8c133'} color={'#000'} text={'Ajouter un produit'} onclick={RemplirForm}/>
      </div>
    
      <div>
        <h1>
          Liste des Produits 
        </h1>
      </div>
      
      <div className='Products FadeIn'>
        
      {filteredItems!==null&&filteredItems.length<=0?'Aucun produit ne correspond a la recherche':

        filteredItems===null? <Loading/> :  filteredItems.map((produit,id)=>{ return (<Product key={id} prodDetails={produit}/>)})

      }

        <ConfirmDialog/>

        
      </div>
    </div>
  )
}

export default Products